import { setCleanBasketEditState } from 'actions/v3/basketEdits';
import { updateBasket } from 'actions/v3/baskets';
import { mapBasketStateToParams } from 'helpers/requestTransformers';
import * as fromDashboard from 'selectors/dashboard';

export const SHOW_PROMOTION_SHOPPABLE_CONFIRMATION_MODAL =
  'SHOW_PROMOTION_SHOPPABLE_CONFIRMATION_MODAL';
export const HIDE_PROMOTION_SHOPPABLE_CONFIRMATION_MODAL =
  'HIDE_PROMOTION_SHOPPABLE_CONFIRMATION_MODAL';
export const HIDE_BEHAVIORAL_DISCOUNT_SHOPPABLE_CONFIRMATION_MODAL =
  'HIDE_BEHAVIORAL_DISCOUNT_SHOPPABLE_CONFIRMATION_MODAL';

export const showShoppablePromotionConfirmationModal = (
  menuSlug,
  mealIds,
  basketWasInitiallySkipped
) => ({
  type: SHOW_PROMOTION_SHOPPABLE_CONFIRMATION_MODAL,
  menuSlug,
  mealIds,
  basketWasInitiallySkipped,
});

export const hideShoppablePromotionConfirmationModal = () => ({
  type: HIDE_PROMOTION_SHOPPABLE_CONFIRMATION_MODAL,
});

export const hideBehavioralDiscountShoppableConfirmationModal = () => ({
  type: HIDE_BEHAVIORAL_DISCOUNT_SHOPPABLE_CONFIRMATION_MODAL,
});

export const saveShoppableBasketEdits = menuSlug => {
  return async (dispatch, getState) => {
    const state = getState();
    const basket = fromDashboard.selectBasket(state, menuSlug);
    const mealServings = fromDashboard.selectMealServingsForBasketEdits(state);
    const selectedMealOptions = fromDashboard.selectMealOptionsForBasketEdits(state);
    const params = mapBasketStateToParams(basket, { mealServings, selectedMealOptions });
    const response = await dispatch(updateBasket(basket.slug, params));

    if (response.ok) dispatch(setCleanBasketEditState(mealServings, selectedMealOptions));

    return fromDashboard.selectBasket(getState(), menuSlug);
  };
};
